import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {CommunicationContentEditorComponent} from './communication-content-editor.component';
import {ButtonModule} from "../../../../../core/component/button/button.module";
import {CardModule} from "../../../../../core/component/card/card.module";
import {FormFieldModule} from "../../../../../core/component/form-field/form-field.module";
import {LoadingModule} from "../../../../../../components/common/loading/loading.module";
import {
    LovValueSelectFilterModule
} from "../../../../../common/lov/lov-value/api/component/lov-value-select-filter/lov-value-select-filter.module";
import {RichTextEditorModule} from "../../../../../../components/common/rich-text-editor/rich-text-editor.module";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {
    WorkflowTaskItemModule
} from "../../../../../workflow/task/api/component/workflow-task-item/workflow-task-item.module";
import {SelectModule} from "../../../../../../components/common/select/select.module";
import {ErrorTextModule} from "../../../../../core/component/error-text/error-text.module";
import {RephraseDialogComponent} from "../../../../ai/api/component/rephrase-dialog/rephrase-dialog.component";
import {SpellCheckDialogComponent} from "../../../../ai/api/component/spell-check-dialog/spell-check-dialog.component";
import {ChipsComponent} from "../../../../../core/component/chips/chips.component";
import {ExpandableContentModule} from "../../../../../core/component/expandable-content/expandable-content.module";
import {ChipComponent} from "../../../../../core/component/chip/chip.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ButtonModule,
        CardModule,
        FormFieldModule,
        LoadingModule,
        LovValueSelectFilterModule,
        RichTextEditorModule,
        DragDropModule,
        WorkflowTaskItemModule,
        SelectModule,
        ErrorTextModule,
        RephraseDialogComponent,
        SpellCheckDialogComponent,
        ChipsComponent,
        ExpandableContentModule,
        ChipComponent,
    ],
    declarations: [
        CommunicationContentEditorComponent,
    ],
    exports: [
        CommunicationContentEditorComponent
    ],
})
export class CommunicationContentEditorModule {}
